import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { TENANT_SLUG } from '../../lib/tenant';
import styles from './ContactModal.module.css';

interface ContactModalProps {
  onClose: () => void;
}

const ContactModal: React.FC<ContactModalProps> = ({ onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState(''); // honeypot
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      toast.error('Molimo popunite ime, e-mail i poruku.');
      return;
    }

    setSending(true);
    try {
      const res = await fetch('/notifications/v1/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(TENANT_SLUG ? { 'X-Tenant-Slug': TENANT_SLUG } : {}),
        },
        body: JSON.stringify({ name, email, phone, message, website }),
      });

      if (res.status === 429) {
        toast.error('Poslali ste previše poruka. Pokušajte kasnije.');
        return;
      }
      if (!res.ok) throw new Error(String(res.status));

      toast.success('Poruka je poslata. Javićemo vam se uskoro.');
      onClose();
    } catch (err) {
      console.error('Greška prilikom slanja poruke:', err);
      toast.error('Slanje nije uspelo. Molimo pokušajte ponovo.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose} aria-label="Zatvori">
          ×
        </button>
        <h2>Kontaktirajte nas</h2>
        <p className={styles.intro}>Popunite formu i odgovorićemo vam na e-mail.</p>

        <form onSubmit={handleSubmit} className={styles.contactForm}>
          <div className={styles.formGroup}>
            <label htmlFor="contact-name">Ime i prezime *</label>
            <input
              type="text"
              id="contact-name"
              value={name}
              maxLength={100}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="contact-email">E-mail *</label>
            <input
              type="email"
              id="contact-email"
              value={email}
              maxLength={150}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="contact-phone">Telefon (opciono)</label>
            <input
              type="tel"
              id="contact-phone"
              value={phone}
              maxLength={50}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="contact-message">Poruka *</label>
            <textarea
              id="contact-message"
              value={message}
              rows={5}
              maxLength={4000}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>

          <div className={styles.honeypot} aria-hidden="true">
            <label htmlFor="contact-website">Sajt</label>
            <input
              type="text"
              id="contact-website"
              value={website}
              tabIndex={-1}
              autoComplete="off"
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>

          <button type="submit" className={styles.submitButton} disabled={sending}>
            {sending ? 'Slanje...' : 'Pošalji'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
